export const LINK_TYPE_OPTIONS = [
  { id: "principal", name: "Principal" },
  { id: "subuser", name: "Sub usuário" },
  { id: "orphan", name: "Orfão" },
];

export const STATUS_OPTIONS = [
  { id: "active", name: "Ativo" },
  { id: "inactive", name: "Inativo" },
];
